import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.css'
})
export class StatusBadgeComponent {
  @Input() status: string = '';

  getStatusClass(): string {
    switch (this.status.toLowerCase()) {
      case 'active':
        return 'status-active';
      case 'approved':
        return 'status-approved';
      case 'pending':
        return 'status-pending';
      case 'draft':
        return 'status-draft';
      default:
        return 'status-default';
    }
  }
}
